import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";

import { NUMERICLABEL_PARAMS } from "components/Monitoring/MainGraph";

import styles from "./style.module.css";

import { Button, NumberLabel } from "aible";

export default class Scenarios extends React.PureComponent {
  render() {
    const {
      showAllScenarios,
      updateShowAllScenarios,
      scenarios,
      scenarioIndex,
      currentScenario,
      isContinuous,
      showOnlyDeployed,
      setupLabels
    } = this.props;
    let selectedScenario = currentScenario;
    if (!selectedScenario && scenarioIndex) {
      scenarios.forEach((s) => {
        if (s.index === scenarioIndex) {
          selectedScenario = s;
        }
      });
    }
    const sortedScenario = [...scenarios].sort((a, b) => (isContinuous ? a.cost - b.cost : b.profit - a.profit));
    const retScenarios = showAllScenarios
      ? sortedScenario
      : sortedScenario.filter((s, i, sList) => {
          if (s.index === selectedScenario.index) {
            return true;
          }
          if (showOnlyDeployed) {
            return false;
          }
          return i === 0 || i === sList.length - 1;
        });

    let hideShowAll = showOnlyDeployed ? true : false;
    if (sortedScenario.length <= 3) {
      if (sortedScenario.length < 3) {
        hideShowAll = true;
      } else {
        if (sortedScenario[1] && sortedScenario[1].index === selectedScenario.index) {
          hideShowAll = true;
        }
      }
    }
    return (
      <div className={styles.scenariosWrapper + " " + (showAllScenarios ? "" : styles.hide)}>
        <div className={styles.scenariosTitle}>
          <div className={styles.mainGraphContentTitle}>
            {retScenarios.length === 1 ? "Deployed Scenario" : "Scenarios"}
          </div>
          {hideShowAll ? (
            ""
          ) : (
            <a className={styles.scenariosToggle} onClick={updateShowAllScenarios}>
              {showAllScenarios ? "Hide" : "See All"}
            </a>
          )}
        </div>
        <div className={styles.scenariosBody}>
          {retScenarios.map((s, i, sList) => (
            <ScenarioCard
              key={"scard" + s.index}
              data={s}
              selectedScenario={selectedScenario}
              isBest={i === 0}
              isWorst={i === sList.length - 1}
              showAllScenarios={showAllScenarios}
              isContinuous={isContinuous}
              showOnlyDeployed={showOnlyDeployed}
              setupLabels={setupLabels}
            />
          ))}
        </div>
      </div>
    );
  }
}

class ScenarioCard extends React.PureComponent {
  render() {
    const { data, selectedScenario, isBest, isWorst, showAllScenarios, isContinuous, showOnlyDeployed, setupLabels } =
      this.props;

    let title = data.name ? data.name : "Scenario " + data.index;
    let modifier = "";
    let cardClass = styles.selected;
    if (selectedScenario && data.index === selectedScenario.index) {
      cardClass = styles.isSelected;
      if (showOnlyDeployed) {
        modifier = "";
      } else if (showAllScenarios) {
        modifier = " (Deployed)";
      } else {
        title = "Deployed Scenario";
      }
    } else if (isBest) {
      cardClass = styles.isBest;
      if (showAllScenarios) {
        modifier = " (Best)";
      } else {
        title = "Best Case";
      }
    } else if (isWorst) {
      cardClass = styles.isWorst;
      if (showAllScenarios) {
        modifier = " (Worst)";
      } else {
        title = "Worst Case";
      }
    } else if (data.profit > selectedScenario.profit) {
      cardClass = styles.isBetter;
    } else {
      cardClass = styles.isWorse;
    }

    title = title + modifier;
    return (
      <div className={styles.scenarioCardWrapper + " " + cardClass}>
        {/* <OverlayTrigger
          placement="top"
          trigger={["hover"]}
          rootClose
          overlay={
            <Popover id="popover-positioned-top">
              <div className={styles.popList}>
                {title}
              </div>
            </Popover>
          }
        >
          <div className={styles.scenarioCardTitle}>
            {title}
          </div>
        </OverlayTrigger> */}
        <div className={styles.scenarioCardTitle} title={title}>
          {title}
        </div>
        <div className={styles.scenarioCardBody}>
          <ScenarioCardInfoItem
            label={isContinuous ? setupLabels.profitLabel : setupLabels.profitLabel}
            value={isContinuous ? data.cost : data.profit}
          />
          <ScenarioCardInfoItem
            label={isContinuous ? setupLabels.overPredictAction : setupLabels.revenueLabel}
            value={isContinuous ? data.overCost : data.revenue}
          />
          <ScenarioCardInfoItem
            label={isContinuous ? setupLabels.underPredictAction : setupLabels.costLabel}
            value={isContinuous ? data.underCost : data.cost}
          />
        </div>
      </div>
    );
  }
}

class ScenarioCardInfoItem extends React.PureComponent {
  render() {
    const { label, value } = this.props;

    const isNegative = value < 0 ? "-" : "";
    const retValue = Math.abs(value);

    return (
      <div className={styles.scenarioCardInfoItem}>
        <div className={styles.scenarioCardLabel}>{label}</div>
        <div className={styles.scenarioCardValue}>
          {isNegative + "$"}
          <NumberLabel style={{ display: "inline" }} params={NUMERICLABEL_PARAMS}>
            {retValue}
          </NumberLabel>
        </div>
      </div>
    );
  }
}
